import React, { useEffect, useState } from "react";
import { NavLink, useSearchParams } from "react-router-dom";
import { initializeApp } from "firebase/app";
import { getFirestore, collection, getDocs } from "firebase/firestore";
import "./styles/products.css";

const firebaseConfig = {
  apiKey: "AIzaSyDO-ivCiTJcGRD4ZQVxEefflp8dXigy_Fo",
  authDomain: "hellocar-777.firebaseapp.com",
  projectId: "hellocar-777",
  storageBucket: "hellocar-777.appspot.com",
};

initializeApp(firebaseConfig);
const db = getFirestore();

export default function Products() {
  const [products, setProducts] = useState([]);

  // ✅ Reveal Animations on scroll
  // ✅ Reveal Animations (fixed)
useEffect(() => {
  const elements = document.querySelectorAll(".reveal, .reveal-left, .reveal-right");

  // ✅ Instantly activate elements already in view (top section)
  elements.forEach(el => {
    const rect = el.getBoundingClientRect();
    if (rect.top < window.innerHeight - 50) {
      el.classList.add("active");
    }
  });

  // ✅ Observer for scrolling
  const obs = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) entry.target.classList.add("active");
      });
    },
    { threshold: 0.2 }
  );

  elements.forEach(el => obs.observe(el));

  return () => obs.disconnect();
}, []);
;

  // ✅ URL PARAMS
  const [searchParams, setSearchParams] = useSearchParams();

  const search = searchParams.get("search") || "";
  const brandFilter = searchParams.get("brand") || "";
  const categoryFilter = searchParams.get("category") || "";

  useEffect(() => {
    const fetchData = async () => {
      const snapshot = await getDocs(collection(db, "helloCarProducts"));
      const list = snapshot.docs.map(doc => ({
        id: doc.id,
        data: doc.data()
      }));
      setProducts(list);
    };
    fetchData();
  }, []);

  const [tempSearch, setTempSearch] = useState(search);
  const onSearch = () => updateURL("search", tempSearch);

  // ✅ Unique field extraction
  const uniqueBrands = [...new Set(products.map(p => p.data.brand).filter(Boolean))];
  const uniqueCategories = [...new Set(products.map(p => p.data.type).filter(Boolean))];

  // ✅ Update URL helper
  const updateURL = (key, value) => {
    if (value) searchParams.set(key, value);
    else searchParams.delete(key);

    setSearchParams(searchParams);
  };

  // ✅ FILTERING
  const filteredProducts = products.filter(p => {
    const nameMatch = p.data.name.toLowerCase().includes(search.toLowerCase());
    const brandMatch = brandFilter ? p.data.brand === brandFilter : true;
    const categoryMatch = categoryFilter ? p.data.type === categoryFilter : true;

    return nameMatch && brandMatch && categoryMatch;
  });

  return (
    <div className="product-page">

      <h1 className="product-title reveal">Products</h1>

      {/* ✅ SEARCH BAR */}
      <div className="product-search-wrapper reveal-left">
        <input
          type="text"
          className="product-search-input"
          placeholder="Search product name..."
          value={tempSearch}
          onChange={(e) => setTempSearch(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && onSearch()}
        />
        <button className="search-btn" onClick={onSearch}>Search</button>
      </div>

      {/* ✅ FILTER BAR */}
      <div className="product-filter-wrapper reveal-right">
        <select
          className="product-filter-select"
          value={brandFilter}
          onChange={(e) => updateURL("brand", e.target.value)}
        >
          <option value="">Filter by Brand</option>
          {uniqueBrands.map(brand => (
            <option key={brand} value={brand}>{brand}</option>
          ))}
        </select>

        <select
          className="product-filter-select"
          value={categoryFilter}
          onChange={(e) => updateURL("category", e.target.value)}
        >
          <option value="">Filter by Category</option>
          {uniqueCategories.map(cat => (
            <option key={cat} value={cat}>{cat}</option>
          ))}
        </select>
      </div>

      {/* ✅ PRODUCT CARDS */}
      <ul className="cardContainer">
        {filteredProducts.map(product => {
          const p = product.data;

          return (
            <NavLink
              className="product-card"
              key={product.id}
              to={`/products/${p.name.split(" ").join("")}?id=${product.id}`}
              state={{ filters: searchParams.toString() }}
            >
              <img
                src={`https://drive.google.com/thumbnail?id=${p.img}&sz=w1000`}
                alt={p.name}
              />

              <div className="info">
                <h4>{p.name}</h4>
                <p className="brand"><b>Brand:</b> {p.brand}</p>
                <p className="type"><b>Category:</b> {p.type}</p>
                <p className="price">₹{p.price} (Per Piece)</p>
              </div>
            </NavLink>
          );
        })}
      </ul>
    </div>
  );
}
